import { createSelector } from '@reduxjs/toolkit';

import { selectIsRestorePage } from 'entities/siteSettings';
import { selectIsMplBlockedForCpc } from 'entities/utmMarks';

import { getPostFormTargetPageName } from './getPostFormTargetPageName';

export const selectPostFormTargetPageName = createSelector(
  [selectIsRestorePage, selectIsMplBlockedForCpc],
  getPostFormTargetPageName,
);
